import { render } from "./UpdateVouchers.vue?vue&type=template&id=a9947db6"
import script from "./UpdateVouchers.vue?vue&type=script&lang=js"
export * from "./UpdateVouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__